import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    storageKey: { type: String, default: 'mobileAppBannerDismissed' }
  }

  connect() {
    // Check if banner was previously dismissed
    if (!localStorage.getItem(this.storageKeyValue)) {
      this.element.classList.remove('d-none')
    } else {
      this.element.remove()
    }
  }

  dismiss(event) {
    event.preventDefault()
    event.stopPropagation()
    localStorage.setItem(this.storageKeyValue, 'true')
    this.element.remove()
  }
} 